var map = {
	"./black/full2.png": "Avno",
	"./blue/full2.png": "SWNk",
	"./white/full2.png": "AWuo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XmLj";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/full2\.png$
// module id = XmLj
// module chunks = 24